/**
 * The product signature: a machine-set, upper-case label sitting above the
 * thing it names — CONTAINER, OVERVIEW, COMMIT, PLAN, WHAT WILL HAPPEN.
 */
const Eyebrow = ({ children, tight = false, className = '' }: {
  children: React.ReactNode,
  /** One notch tighter tracking, for labels nested inside a tile row. */
  tight?: boolean,
  className?: string
}) => (
  <span className={`${tight ? 'b4-eyebrow-tight' : 'b4-eyebrow'} ${className}`}>{children}</span>
)

export default Eyebrow
